module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "popup--inner"
  }, [_c('h2', {
    staticClass: "popup--title"
  }, [_vm._v("\n            You sucessfully removed " + _vm._s(_vm.resource) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "popup--paragraph"
  }, [_vm._v("\n            Deleted " + _vm._s(_vm.resourcePlural) + " are permanently deleted. You cannot revert this action.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "popup--buttons",
    on: {
      "click": _vm.close
    }
  }, [_c('button', {
    staticClass: "popup--buttons-item btn btn_grey"
  }, [_vm._v("\n                OK\n            ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-82ed567c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82ed567c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/modal_ok.vue
// module id = 452
// module chunks = 1